<template>
    <Link
        as="button"
        class="btn btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bold px-5"
        :href="href"
        :class="{'pointer-events-none opacity-50': disabled}">
        <slot/>
    </Link>
</template>

<script>
import { Link } from '@inertiajs/vue2';

export default {
    components: {Link},

    props: {
        disabled: Boolean,
        href: String
    }
}
</script>
